import _sfc_main from './button.vue.js';
/* empty css            */
import _export_sfc from '../../_virtual/_plugin-vue_export-helper.js';

const button = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-36a102fd"]]);

export { button as default };
//# sourceMappingURL=button.js.map
